import { Platform } from "react-native";

/**
 * True when the app is running in a mobile browser (Expo web on phone/tablet).
 * Used to enable camera barcode scanning only on mobile web, not desktop.
 */
export function isMobileWeb() {
  if (Platform.OS !== "web" || typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent || "";
  const mobileUa = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const zebraUa = /Zebra|TC[0-9]{2}|Symbol/i.test(ua);
  const coarsePointer =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(pointer: coarse)").matches;
  const narrowViewport = typeof window !== "undefined" && window.innerWidth <= 900;
  return mobileUa || zebraUa || coarsePointer || narrowViewport;
}

export function isAndroidWeb() {
  if (Platform.OS !== "web" || typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent || "");
}

/** Zebra tablets / touch browsers where hardware laser wedge runs (not desktop web). */
export function shouldUseHardwareWedge() {
  if (Platform.OS !== "web" || typeof window === "undefined") return false;
  if (isMobileWeb()) return true;
  if (typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent || "")) return true;
  if ("ontouchstart" in window) return true;
  return false;
}

/**
 * Ref callback for TextInput on mobile web — keeps plain text inputs (never type=search)
 * and applies autocomplete-off attributes.
 */
export function noAutofillRef(existingRef) {
  return (el) => {
    if (typeof existingRef === "function") {
      existingRef(el);
    } else if (existingRef && typeof existingRef === "object") {
      try {
        existingRef.current = el;
      } catch (e) {}
    }
    if (Platform.OS !== "web" || !el) return;
    if (!isMobileWeb()) return;
    try {
      const tag = (el.tagName || "").toUpperCase();
      if (tag === "INPUT") {
        if (el.type === "search") el.type = "text";
        el.setAttribute("autocomplete", "off");
        el.setAttribute("autocorrect", "off");
        el.setAttribute("autocapitalize", "off");
        el.setAttribute("spellcheck", "false");
        el.setAttribute("enterkeyhint", "done");
        el.setAttribute("inputmode", "text");
      }
      const cls = el.getAttribute("class") || "";
      if (!cls.includes("no-autofill-input")) {
        el.setAttribute("class", (cls + " no-autofill-input").trim());
      }
    } catch (e) {}
  };
}

/**
 * Plain props version for inputs that don't expose a settable ref easily.
 */
export function getNoAutofillProps() {
  if (Platform.OS !== "web") return {};
  return {
    autoComplete: "off",
    autoCorrect: false,
    spellCheck: false,
  };
}
